import styled from "@emotion/styled";
import theme from "../../../styles/theme";

export const SearchBoxBase = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
`;

export const SearchBoxInput = styled.div`
  width: 100%;
`;

export const AutocompleteResults = styled.div`
  flex: 1 0 auto;
  width: 100%;
  height: 0px;
  position: relative;

  button {
    // background-color: transparent;

    svg {
      color: ${theme.colors.darkBlues[100]} !important;
    }
  }
`;
